(ns frontend.test.validation.view
  (:require
   [frontend.test.validation.event]
   [frontend.test.validation.sub]
   [frontend.test.validation.immediate :as immediate]
   [frontend.test.validation.blur :as blur]
   [frontend.test.validation.submit :as submit]
   [ui.util :as uu]
   [ui.view.page.view :as page]))


(defn view
  []
  [page/centered
   [:div
    {:class (uu/cm "gap-4")}
    [immediate/view]
    [blur/view]
    [submit/view]]])
